import React, {
  memo
} from "react";
import {
  StyleSheet
} from "react-native";
import {
  Card
} from "@constants/Themed";
import UsageStatMonitor from "../../SettingsScreens/Components/UsageStatMonitor";

const UsageStatWidget = () => (
  <Card style={styles.card}>
    <UsageStatMonitor />
  </Card>
);

const styles = StyleSheet.create({
  card: {
    width: "100%",
    height: "100%",
    borderRadius: 15,
    overflow: "hidden",
    padding: 16,
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
});

export default memo(UsageStatWidget);
